import {useLocation} from "react-router-dom";

function Metadata() {
    const location = useLocation();
    const path = decodeURIComponent(location.pathname);

    let title = "meliconcepts";
    let description =
        "Fotorealistische 3D-Visualisierungen für Immobilien – für Makler, Baufirmen & " +
        "Privatkunden. Emotional, greifbar & ideal für fundierte Entscheidungen.";

    switch (path) {
        case "/über-mich":
            title = "Über mich - meliconcepts";
            description =
                "Erfahren Sie mehr über die Person hinter meliconcepts – mit Leidenschaft für Architektur, Visualisierung und individuelle Kundenlösungen.";
            break;
        case "/impressum":
            title = "Impressum - meliconcepts";
            description =
                "Impressum meliconcepts – gesetzliche Angaben, Kontaktinformationen und Verantwortliche gemäß § 5 TMG.";
            break;
        case "/datenschutz":
            title = "Datenschutz - meliconcepts";
            description =
                "Datenschutzerklärung meliconcepts – alle Informationen zur Erhebung, Nutzung und Speicherung personenbezogener Daten gemäß DSGVO.";
            break;
        default:
            break;
    }

    return (
        <>
            <title>{title}</title>
            <meta name="description" content={description} />
        </>
    );
}

export default Metadata;
